import React, { useContext } from 'react';
import styled from 'styled-components';
import { Player, ControlBar } from 'video-react';
import '../../node_modules/video-react/dist/video-react.css';
import RaisedButton from './Buttons/RaisedButton';
import Context from '../Context';
import { getClip, getRelatedVideoIds } from '../utils';
import {
  dropShadow, width100, flexColumn, border3D,
} from '../constants';

const VideoPlayer = styled.div`
  ${dropShadow}
  ${width100}
  ${flexColumn}
  ${border3D}
  display: flex;
  max-width: 20rem;
  border-color: #393939;
  margin: 0.5rem;

  div {
    flex-grow: 1;
  }

  ${props => (props.done ? ''
    : `:hover {
    max-width: 40rem;
    flex-grow: 1;
  }`)}
`;

const videoButton = {
  width: '100',
  height: '3rem',
  fontSize: '1.25rem',
  filter: 'none',
  borderWidth: '7px',
};

export default function Video(props) {
  const { name } = props;
  const source = getClip(name);
  const {
    setClips, narrative, done,
  } = useContext(Context);

  const nextChapter = () => {
    const relatedVidIds = getRelatedVideoIds(name);

    if (!narrative.includes(name)) {
      narrative.push(name);
    }

    const nextVidIds = relatedVidIds.filter(id => !(narrative.includes(id)));

    if (nextVidIds.length > 0) {
      setClips(nextVidIds);
    } else {
      setClips(narrative);
    }
  };

  return (
    <VideoPlayer className={`video-${name}`} done={done}>
      <Player
        muted
        autoPlay
        loop
        poster="/assets/poster.png"
      >
        <source src={source.clip} />
        <ControlBar disableCompletely />
      </Player>
      {!done && (
      <RaisedButton
        background="yellow"
        hover="red"
        color="red"
        style={videoButton}
        onClick={nextChapter}
      >
        +
      </RaisedButton>
      )}
    </VideoPlayer>
  );
}
